import React from 'react';
import { useLocation } from 'react-router-dom';

export default function PlaceholderPage({ title, description }) {
  const location = useLocation();
  const pageName = title || location.pathname.split('/').pop().replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  
  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-8">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-purple-100 to-purple-200 rounded-lg flex items-center justify-center">
            <svg className="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">{pageName}</h1>
          <p className="text-slate-600 mb-6">
            {description || `This is the ${pageName} page. Content and functionality will be implemented here.`}
          </p>
          <div className="bg-slate-50 rounded-lg p-4 text-left">
            <h3 className="text-sm font-semibold text-slate-700 mb-2">Development Information</h3>
            <ul className="text-sm text-slate-600 space-y-1">
              <li><strong>Current Path:</strong> {location.pathname}</li>
              <li><strong>Page Status:</strong> Placeholder - Ready for Implementation</li>
              <li><strong>Next Steps:</strong> Create dedicated component and add functionality</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}